export default __webpack_public_path__ + "static/media/george.876658b2.jpg";